// @vue/component
export default {
  name: 'ConversationSearchListBox',
};
